import React from 'react'
import { Button } from 'antd'
import { useTranslation } from 'next-i18next'
import { FileZipOutlined } from '@ant-design/icons'
import { CustomCard, CustomTable } from 'src/components'
import { getCalculateFootprintSelector } from 'src/features'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { calculateResultsColumns } from 'src/core/table-columns'
import { downloadFile } from 'src/features/manage-cabify-process/actions'
import { downloadFileSelector } from 'src/features/manage-cabify-process/selectors'


const CalculateResultsList: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { loading: loadingCalculate, results } = useAppSelector(getCalculateFootprintSelector)
  const { loading: downloadFileLoading } = useAppSelector(downloadFileSelector)

  const handlerOnClick = () => {
    dispatch(downloadFile(results))
  }

  return <CustomCard
    loading={loadingCalculate}
    cardTitle={t('Cabify.CalculateResults')}
    extra={
      <Button
        type='primary'
        shape='round'
        disabled={ !results && results?.length !== 0 }
        loading={ downloadFileLoading || loadingCalculate }
        onClick={ handlerOnClick }
        className='radius-100'
        icon={ <FileZipOutlined /> }
      > {t('Cabify.DownloadAll')}
      </Button>}
  >
    <CustomTable
      scroll={{ x: 130 }}
      columns={calculateResultsColumns}
      dataSource={results}
    />
  </CustomCard>
}

export default CalculateResultsList
